/**
 * Watertap Blog Search — Live AJAX search for blog articles
 */
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('wt-blog-search-input');
  const resultsContainer = document.getElementById('wt-blog-search-results');
  
  if (!searchInput || !resultsContainer) return;

  // All articles data embedded in the page
  const articles = JSON.parse(document.getElementById('wt-blog-data').textContent);

  let debounceTimer;

  searchInput.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    const query = this.value.trim().toLowerCase();
    
    if (query.length < 2) {
      resultsContainer.classList.remove('active');
      return;
    }

    debounceTimer = setTimeout(() => {
      const matches = articles.filter(a => {
        return a.title.toLowerCase().includes(query) || 
               a.excerpt.toLowerCase().includes(query) ||
               a.category.toLowerCase().includes(query);
      });

      resultsContainer.innerHTML = '';
      
      if (matches.length === 0) {
        resultsContainer.innerHTML = '<div class="no-results">No articles found for "' + query + '"</div>';
      } else {
        matches.slice(0, 8).forEach(article => {
          const a = document.createElement('a');
          a.href = article.url;
          a.innerHTML = '<img src="' + article.image + '" alt="" loading="lazy">' +
            '<div><div class="result-title">' + article.title + '</div>' +
            '<div class="result-category">' + article.category + '</div></div>';
          resultsContainer.appendChild(a);
        });
      }
      
      resultsContainer.classList.add('active');
    }, 300);
  });

  // Close on click outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.wt-blog-search')) {
      resultsContainer.classList.remove('active');
    }
  });

  // Category filter pills
  const pills = document.querySelectorAll('.wt-blog-cat-pill');
  const grid = document.getElementById('wt-blog-grid');
  const cards = grid ? grid.querySelectorAll('.wt-blog-card, .wt-blog-featured') : [];
  const empty = document.getElementById('wt-blog-empty');

  pills.forEach(pill => {
    pill.addEventListener('click', function(e) {
      e.preventDefault();
      const cat = this.dataset.cat;
      
      pills.forEach(p => p.classList.remove('active'));
      this.classList.add('active');

      let visibleCount = 0;
      cards.forEach(card => {
        const cardCat = card.dataset.category || 'all';
        if (cat === 'all' || cardCat === cat) {
          card.style.display = '';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      if (empty) {
        empty.style.display = visibleCount === 0 ? 'block' : 'none';
      }
    });
  });

  // FAQ toggle on article pages
  document.querySelectorAll('.wt-faq-question').forEach(q => {
    q.addEventListener('click', function() {
      this.parentElement.classList.toggle('open');
    });
  });
});
